import onSuggestionsProcessed from '../actions/onSuggestionsProcessed';
import getScenarioStore from '../store/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(onSuggestionsProcessed, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).currentSuggestions = actionMessage.suggestionSet;

    /**
     * When new suggestions are processed, reset the selectedSuggestionIndex
     * since the selected suggestion will have been removed from the store.
     */
    getScenarioStore(
        actionMessage.scenarioId
    ).selectedSuggestionIndex = createDefaultSearchStore().selectedSuggestionIndex;
});
